module.exports = __webpack_public_path__ + "static/media/new_icon.f4190c49.png";